import { Measure } from '../common/measure';

require('./stat-table.component.scss');

/*@ngInject*/
class StatTableController {
  constructor($scope, $element, CurrentModelService, RouterService) {
    this.$element = $element;
    this.CurrentModelService = CurrentModelService;
    this.RouterService = RouterService;
    this.getMeasure = Measure.getMeasure;
    this.getMeasureLabel = Measure.getMeasureLabel;
    // $scope.$watch('$ctrl.filterData', (data) => {
    //   console.log(data);
    // });

    $scope.$on('resize', () => {
      $scope.$digest();
    });
    $scope.$on('splitterChanged', () => {
      $scope.$digest();
    });
  }

  drilldown(drill, cell) {
    for(let i = 0; i < this.filterData.filter.drilldown.length; ++i) {
      let drilldown = this.filterData.filter.drilldown[i];
      this.RouterService.drilldownFilter(
        this.CurrentModelService.model.getCellFilter(drilldown, cell));
      if (drill === drilldown) {
        break;
      }
    }
  }

  barWidth(cell) {
    const measure = this.filterData.filter.measure;
    let width = (cell[measure] * 100 /
      this.filterData.filterData.cells[0][measure]) + '%';
    return width;
  }

  barContainerWidth() {
    const width = this.$element.width() / (this.filterData.filter.drilldown.length + 2);
    return width + 'px';
  }
}

export const StatTableComponent = {
  template  : require('./stat-table.component.html'),
  bindings  : {
    model    : '<',
    filterData: '<',
    filter   : '<',
  },
  controller: StatTableController,
};



// WEBPACK FOOTER //
// ./src/stat/stat-table.component.js